import * as React from 'react';
export const bomSvg = React.forwardRef(function bomSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0079C1',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M16 6.05a9.95 9.95 0 1 1 0 19.9 9.95 9.95 0 0 1 0-19.9zm-4.76 12.11v2.6h9.52v-2.6h-9.52zm4.45-4.51L14 11.45c-.21-.27-.48-.27-.7 0l-2.06 2.59v4.12l2.04-2.6c.25-.3.5-.29.74 0l1.65 2.17c.24.3.47.3.7 0L18 15.56c.24-.3.51-.3.75 0l2 2.6v-4.14l-2.02-2.58c-.21-.26-.47-.26-.69 0l-1.67 2.2c-.12.17-.22.21-.34.22-.1 0-.22-.05-.34-.21z',
      }),
    ),
  );
});
bomSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bom = {
  category: 'brand',
  colorable: false,
  name: 'bom',
  svg: bomSvg,
};
